import { GROUP_COLORS } from '../../constants';

export const groupColorMap = GROUP_COLORS.colorMap;

export const getGroupColorByCSSClass = (cssClass) => groupColorMap[cssClass] || groupColorMap['.groupColorUngrouped'];

export const getGroupColorCssClasses = () => GROUP_COLORS.colorClasses;
